import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';

@Injectable()
export class ReservationService extends DataService {

  constructor(private http: HttpClient, protected injector: Injector, protected store: Store<any>) {
    super(injector, store);
  }

  getExcelReservationsMacro(page, limit, search?, find?) {
    let params = search ? `&${search}` : '';
    return this.http.get(`${environment.apiUrl}/admin-macro/v1/reservations/download?page=${page}&rowsPerPage=${limit}&${params}`);
  }

  fetchReservation(page, limit, search?, find?) {
    let params = search ? `&${search}` : '';
    params = find ? `${params}&find=${find}` : `${params}`;
    return this.http
      .get(`${environment.apiUrl}/reservation?page=${page}&rowsPerPage=${limit}${params}`)
      .toPromise()
      .then((res) => {
        return res || [];
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  }

  fetchReservationExcel(page, limit, search?, find?) {
    let params = search ? `&${search}` : '';
    // VDS-3444: mismo scope que getReservations. El backend lee `unit` (no `unitId`).
    const unitId = this.getProprietorUnitId();
    if (unitId) params += `&unit=${unitId}`;
    return this.http.get(`${this.legacyRoleV1Url('reservations/download')}?page=${page}&rowsPerPage=${limit},${params}`);
  }

  getReservations(page, limit, search?, find?) {
    let params = search ? `&${search}` : '';
    const unitId = this.getProprietorUnitId();
    if (unitId) params += `&unit=${unitId}`;
    params = find ? `${params}&find=${find}` : `${params}`;
    return this.http
      .get(`${this.legacyRoleV1Url('reservations/paginate')}?page=${page}&rowsPerPage=${limit}${params}`)
      .toPromise()
      .then((res) => {
        return res || [];
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  }

  storeReservation(reservation) {
    return this.http
      .post(`${this.legacyRoleV1Url('reservations')}`, reservation)
      .toPromise()
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.log('errr: ', err);
        return Promise.reject(err);
      });
  }

  updateReservation(reservation) {
    const building = this.getBuilding();
    reservation.building_id = building._id;
    return this.http
      .put(`${environment.apiUrl}/reservation/${reservation.id}`, { reservation })
      .toPromise()
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.log('errr: ', err);
        return Promise.reject(err);
      });
  }

  updateStatus(id, status) {
    return this.http
      .patch(`${this.legacyRoleV1Url('reservations')}/${id}`, { status })
      .toPromise()
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.log('errr: ', err);
        return Promise.reject(err);
      });
  }

  uploadPayment(id, files) {
    const formdata: FormData = new FormData();
    formdata.append('file', files);

    return this.http
      .post(`${this.legacyRoleV1Url('reservations')}/${id}/paid`, formdata)
      .toPromise()
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  }
}
